__turbopack_context__.v({
  "arrow-icon": "SelectInput-module__4RGgRa__arrow-icon",
  "clear-icon": "SelectInput-module__4RGgRa__clear-icon",
  "clearable": "SelectInput-module__4RGgRa__clearable",
  "icon": "SelectInput-module__4RGgRa__icon",
  "lc-select-input": "SelectInput-module__4RGgRa__lc-select-input",
  "lc-select-popover": "SelectInput-module__4RGgRa__lc-select-popover",
});
